
import { get, postJson } from '../utils/http'

export const fetchSba = (id) => (get('SBA_FETCH', `/admin/sba/${id}`))

export const editSba = (payload) => ({ type: 'SBA_EDIT', payload })

export const save = ({ id, after, content, contentFuture }) => {


  let body = {
    id,
    after,
    content,
    contentFuture
  };

  return postJson('SBA_SAVE', '/admin/sba/update', body);

}


// WEBPACK FOOTER //
// ./src/sba/sbaActions.js